import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { IonModal, ToastController } from '@ionic/angular';
import { BerService } from '../ber.service';
import { BER_OPCIOK, honapNev } from '../ber.opciok';

// BER átalányadós: az egyéni vállalkozó (alkalmazottként, EV-jogviszonnyal) átalányadózásának
// negyedéves számfejtése HAVI bontásban (RLB-szerű): havi árbevétel → jövedelem/adómentes/SZJA-alap/
// Tb-alap/Szoc-alap, göngyölítve, majd negyedéves és göngyölített összegzés. Költséghányad a jogviszonyból.
@Component({
  selector: 'app-ber-atalany',
  templateUrl: './atalany.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../ber-shared.scss'],
})
export class AtalanyComponent implements OnInit {
  @ViewChild('szerkModal') szerkModal: IonModal;
  jogviszonyok: any[] = [];
  valasztott: any = null;
  negyedevek: any[] = [];            // a 4 negyedév összesítője a kártyákhoz
  evek: number[] = [];
  khanyadok = BER_OPCIOK.koltseghanyad;
  honapNev = honapNev;

  szerk: any = null;                 // { negyedev, honapok:[3], elozo, negyedevOssz, mindossz }
  naploKotott = false;
  naplobolFut = false;

  constructor(private ber: BerService, private toast: ToastController, private router: Router, private http: HttpClient) {}

  /*  A NEGYEDÉV BEVALLÁSA (2658). Az átalányadózó egyéni vállalkozó negyedéves bevallását a NAV
   *  csak az online kitöltőjében adja közre (XSD és ÁNYK-csomag nincs hozzá), ezért a sablont onnan
   *  hozzuk le: kitölteni és nyomtatni lehet, beküldeni egyelőre az ONYA-ban kell. A gomb
   *  megnyitja (vagy létrehozza) a negyedév bevallását – az azonosító adatok és az időszak
   *  előtöltve; a járulék-sorokat a fenti havi bontás alapján kell kitölteni. */
  bevallasFut = false;
  private ny<T = any>(ut: string, test?: any): Promise<T> {
    const url = '/api/nav-nyomtatvany' + ut;
    return firstValueFrom(test === undefined ? this.http.get<T>(url) : this.http.post<T>(url, test));
  }
  async bevallasNyit() {
    const negyedev = this.szerk?.negyedev;
    if (!negyedev || !this.aktiv.ugyfelId) return;
    this.bevallasFut = true;
    try {
      // A végpont { sorok, parok } alakban válaszol (a párosított NAPLO-ügyfél bevallásaival).
      const r: any = await this.ny(`/bevallasok/BER/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`);
      const lista: any[] = Array.isArray(r) ? r : (r?.sorok || []);
      let b = lista.find((x) => x.kod === '2658' && Number(x.negyedev) === negyedev && x.allapot !== 'elutasitva');
      if (!b) {
        const katalogus: any = await this.ny('/katalogus');
        if (!(katalogus.lista || []).some((k: any) => k.kod === '2658' && k.letoltve)) await this.ny('/sablon/2658/letolt', {});
        b = await this.ny('/bevallas', { modul: 'BER', ugyfel_id: this.aktiv.ugyfelId, kod: '2658',
          ev: this.aktiv.ev, gyakorisag: 'negyedeves', negyedev });
      }
      await this.szerkModal.dismiss();
      this.router.navigate(['/ber/bevallas', b.id]);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült megnyitni a 2658-as bevallást.'); }
    finally { this.bevallasFut = false; }
  }

  async ngOnInit() {
    await this.ber.init();
    const ev = new Date().getFullYear();
    this.evek = [ev + 1, ev, ev - 1, ev - 2];
    await this.betolt();
  }

  get aktiv() { return this.ber.aktiv; }
  async evValt(ev: number) { await this.ber.setAktiv({ ev }); await this.negyedekBetolt(); }

  async betolt() {
    if (!this.aktiv.ugyfelId) return;
    try {
      this.jogviszonyok = await this.ber.get('/atalany/jogviszonyok/' + this.aktiv.ugyfelId);
      const ugyfelek: any[] = await this.ber.get('/ugyfelek/' + this.aktiv.intezmeny);
      const u = ugyfelek.find((x) => x.id === this.aktiv.ugyfelId);
      this.naploKotott = !!u?.naplo_ugyfel_id;
      this.valasztott = this.jogviszonyok[0] || null;
      await this.negyedekBetolt();
    } catch { this.hiba('Nem sikerült betölteni.'); }
  }

  async valasztId(id: string) { const j = this.jogviszonyok.find((x) => x.id === id); if (j) { this.valasztott = j; await this.negyedekBetolt(); } }

  /** Az adott évben ténylegesen alkalmazott hányad: a 45 az „általános” kategória, ami
   *  2025-ig 40%, 2026-ban 45%, 2027-től 50% (backend/ber.js atalanyKoltseghanyad). */
  get effKhanyad(): number {
    const k = Number(this.valasztott?.atalany_koltseghanyad) || 45;
    if (k >= 80) return k;
    const e = Number(this.aktiv?.ev) || new Date().getFullYear();
    return e < 2026 ? 40 : e < 2027 ? 45 : 50;
  }

  get khanyadCimke() {
    const v = this.valasztott?.atalany_koltseghanyad;
    return this.khanyadok.find((k) => k.value === v)?.label || (v ? v + '%' : '—');
  }

  /*  Az év képe: a 4 negyedév (és bennük a 12 hónap) a tárolt havi adatokból, plusz az Évi
   *  paraméterek (minimálbér, kulcsok) – ebből az éves összesítő, a keretek kihasználtsága és a
   *  becsült közterhek. A kulcsok törtként tároltak (0,15 = 15%). */
  honapok: any[] = [];               // a 12 hónap számított sora
  be: any = null;                    // az év paraméterei

  async negyedekBetolt() {
    this.negyedevek = []; this.honapok = [];
    if (!this.valasztott) return;
    try { this.be = await this.ber.get('/beallitas/' + this.aktiv.intezmeny + '?ev=' + this.aktiv.ev); } catch { this.be = null; }
    for (let n = 1; n <= 4; n++) {
      try {
        const r: any = await this.ber.get('/atalany/ho/' + this.aktiv.ugyfelId + this.ber.evq({ negyedev: n, jogviszony_id: this.valasztott.id }));
        const hok = (r.honapok || []).map((h: any) => this.kozteher({ ...h, negyedev: n }));
        this.honapok.push(...hok);
        const t = hok.reduce((a: number, h: any) => a + h.kozteher, 0);
        this.negyedevek.push({ negyedev: n, ...r.negyedevOssz, kozteher: Math.round(t), rogzitettHo: hok.filter((h: any) => Number(h.arbevetel) > 0).length,
          vanAdat: (r.negyedevOssz?.arbevetel || 0) > 0 });
      } catch { this.negyedevek.push({ negyedev: n, vanAdat: false }); }
    }
  }

  private kulcs(v: any): number { const n = Number(v) || 0; return n > 1 ? n / 100 : n; }
  /** Egy hónap becsült közterhei az alapokból és az év kulcsaiból. */
  private kozteher(h: any) {
    const szja = Math.round((Number(h.szja_alap) || 0) * this.kulcs(this.be?.szja_kulcs ?? 0.15));
    const tb = Math.round((Number(h.tb_alap) || 0) * this.kulcs(this.be?.tb_kulcs ?? 0.185));
    const szocho = Math.round((Number(h.szocho_alap) || 0) * this.kulcs(this.be?.szocho_kulcs ?? 0.13));
    const van = Number(h.arbevetel) > 0;
    return { ...h, szja: van ? szja : 0, tb: van ? tb : 0, szocho: van ? szocho : 0, kozteher: van ? szja + tb + szocho : 0, van };
  }

  /** Van-e a hónapok között szja-mentes (anyák kedvezménye, NÉTAK, fiatalok) – csak akkor kell az oszlop. */
  get vanSzjaMentes(): boolean { return this.honapok.some((h) => Number(h.szja_mentes) > 0); }
  ossz(m: string): number { return Math.round(this.honapok.reduce((a, h) => a + (Number(h[m]) || 0), 0)); }
  get szazalekKulcsok() {
    return { szja: Math.round(this.kulcs(this.be?.szja_kulcs ?? 0.15) * 1000) / 10, tb: Math.round(this.kulcs(this.be?.tb_kulcs ?? 0.185) * 1000) / 10,
      szocho: Math.round(this.kulcs(this.be?.szocho_kulcs ?? 0.13) * 1000) / 10 };
  }
  /** Az éves adómentes keret: a minimálbér éves összegének fele (Szja tv. – ugyanígy számol a kiszolgáló). */
  get mentesKeret(): number { return Math.round((Number(this.be?.minimalber) || 0) * 12 * 0.5); }
  /** Az átalányadózás bevételi határa: a minimálbér éves összegének tízszerese (kiskereskedőnél ötvenszerese). */
  // Szja tv. 52. § (1): a minimálbér éves összegének tízszerese; kizárólag kiskereskedelmi
  // tevékenységnél (90%-os költséghányad) az ötvenszerese.
  get bevetelHatar(): number {
    const szorzo = Number(this.valasztott?.atalany_koltseghanyad) === 90 ? 50 : 10;
    return Math.round((Number(this.be?.minimalber) || 0) * 12 * szorzo);
  }
  arany(resz: number, egesz: number): number { return egesz > 0 ? Math.min(100, Math.round((resz / egesz) * 1000) / 10) : 0; }
  get rogzitettHonap(): number { return this.honapok.filter((h) => h.van).length; }

  honapokNegyedevben(n: number) { return [(n - 1) * 3 + 1, (n - 1) * 3 + 2, (n - 1) * 3 + 3]; }

  async uj(negyedev: number) {
    if (!this.valasztott) return;
    try {
      const r: any = await this.ber.get('/atalany/ho/' + this.aktiv.ugyfelId + this.ber.evq({ negyedev, jogviszony_id: this.valasztott.id }));
      this.szerk = { negyedev, ...r };
      await this.szerkModal.present();
      await this.szamol(); // a min.jár.alap és a göngyölítés azonnal jelenjen meg
    } catch { this.hiba('Nem sikerült betölteni a negyedévet.'); }
  }

  // Egy hónap árbevétel/kieső nap változásakor újraszámol (előnézet, nem ment).
  async szamol() {
    if (!this.szerk || !this.valasztott) return;
    const honapok: any = {};
    for (const h of this.szerk.honapok) honapok[h.ho] = { arbevetel: h.arbevetel || 0, kieso_nap: h.kieso_nap || 0, osszes_nap: h.osszes_nap };
    try {
      const r: any = await this.ber.post('/atalany/ho/szamol/' + this.aktiv.ugyfelId + this.ber.evq(), { jogviszony_id: this.valasztott.id, negyedev: this.szerk.negyedev, honapok });
      this.szerk = { negyedev: this.szerk.negyedev, ...r };
    } catch { this.hiba('Számítási hiba.'); }
  }

  async mentes() {
    const honapok: any = {};
    for (const h of this.szerk.honapok) honapok[h.ho] = { arbevetel: h.arbevetel || 0, kieso_nap: h.kieso_nap || 0, osszes_nap: h.osszes_nap };
    try {
      await this.ber.post('/atalany/ho/' + this.aktiv.ugyfelId + this.ber.evq(), { jogviszony_id: this.valasztott.id, negyedev: this.szerk.negyedev, honapok });
      await this.szerkModal.dismiss(); await this.negyedekBetolt(); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Hiba.'); }
  }

  // Egy hónap árbevételének átvétele a NAPLO-ból (az adott hónap árbevétel-tételei).
  async naplobolHo(h: any) {
    this.naplobolFut = true;
    try {
      const r: any = await this.ber.get('/atalany/naplo-bevetel-ho/' + this.aktiv.ugyfelId + this.ber.evq({ ho: h.ho }));
      h.arbevetel = r.bevetel;
      await this.szamol();
      this.ok(`${honapNev(h.ho)}: ${Number(r.bevetel).toLocaleString('hu-HU')} Ft a NAPLO-ból.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült átvenni.'); }
    finally { this.naplobolFut = false; }
  }

  negyed(n: number) { return this.negyedevek.find((s) => s.negyedev === n); }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'danger' })).present(); }
}
